var map = {
	"./Analytics.png": 45161,
	"./AnalyticsActive.png": 70035,
	"./Challenges.png": 66439,
	"./ChallengesActive.png": 16265,
	"./Employees.png": 38194,
	"./EmployeesActive.png": 57564,
	"./Feed.png": 60441,
	"./FeedActive.png": 2243,
	"./GlobalAdmin.png": 97395,
	"./GlobalAdminActive.png": 47325,
	"./History.png": 53265,
	"./HistoryActive.png": 63115,
	"./Market.png": 54969,
	"./MarketActive.png": 76003,
	"./NewTransfer.png": 49850,
	"./NewTransferActive.png": 59412,
	"./NewTransferMobile.png": 6452,
	"./Organization.png": 17736,
	"./OrganizationActive.png": 40090,
	"./SeeMore.png": 38439,
	"./Surveys.png": 21592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88776;